//ignore this APIS when 404 error occurs
export const ignoreAPI = ['login', 'verifyotp', 'download', 'upload']
